import { ISO6391LanguageCode } from './types';

export const setHtmlRootLangAttribute = (locale: ISO6391LanguageCode): void => {
    document.documentElement.lang = locale;
};
